import { useEffect, useState, useRef } from "react";
import { Button, Form, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import WardValidation from "../../../hooks/WardValidation";
import { createUpdateWard } from "../../../store/actions/wardsAction";
import { resetPopup } from "../../../store/reducerSlice/wards";
import { fetchLocationList } from "../../../store/actions/locationsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";

const formElements = [
  {
    key: "type",
    label: "Ward Type",
    placeHolder: "Enter Ward Type",
    type: "select",
    options: [
      "Frailty Virtual",
      "Respiratory Virtual",
      "Physical Ward",
      "Heart Failure Virtual",
      // "IMC"
    ],
  },
  {
    key: "location",
    label: "Geography",
    placeHolder: "Select geography",
    type: "select",
    options: [],
  },
  {
    key: "name",
    label: "Ward Name",
    placeHolder: "Enter ward name",
    type: "text",
  },
  {
    key: "numberOfBeds",
    label: "Number of Beds",
    placeHolder: "Enter no. of beds",
    type: "text",
  },
];

const ManageWard = (props) => {
  const { selectWard } = props;
  console.log("selectWard", selectWard);
  const adminDetail = props.adminDetail;
  console.log("adminDetail", adminDetail);
  // Accessing wardTypes from adminDetail
  const wardTypes = adminDetail?.wardTypes;
  const locationTypes = adminDetail?.locations;
  const [isShow, setIsShow] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [locationOptions, setLocationOptions] = useState(null);
  const [selectLocation, setSelectedLocation] = useState(null);
  const [wardDetail, setWardDetail] = useState({
    location: null,
    type: null,
    numberOfBeds: null,
  });
  const { locations } = useSelector((state) => {
    return state.locations;
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    WardValidation({
      location: wardDetail?.location,
      name: wardDetail?.name ? wardDetail?.name : null,
      type: wardDetail?.type,
      numberOfBeds: wardDetail?.numberOfBeds
        ? wardDetail?.numberOfBeds?.toString()
        : null,
    });

  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector((state) => state.wards);
  // fetch location list
  useEffect(() => {
    if (!Array.isArray(locations)) {
      dispatch(fetchLocationList());
    }
  }, []);
  // set location list
  useEffect(() => {
    if (Array.isArray(locations)) {
      let arr = locations.map((x) => {
        return { _id: x._id, name: x?.name };
      });
      setLocationOptions(arr);
    }
  }, [locations]);

  console.log("geographyOptions-82", locationOptions);
  // set details page
  useEffect(() => {
    if (selectWard === null) {
      setWardDetail({
        location: null,
        type: null,
        name: null,
        numberOfBeds: null,
      });
    } else {
      setWardDetail({
        wardId: selectWard?._id,
        //location: JSON.stringify({name:selectWard?.location,_id:selectWard?.locationId}),
        location: selectWard?.locationId,
        name: selectWard?.name,
        type: selectWard?.type,
        numberOfBeds: selectWard?.numberOfBeds,
      });
    }
  }, [selectWard]);
  // Set ward name
  useEffect(() => {
    console.log("wardDetail location 104 ", wardDetail?.location);
    if (selectWard === null) {
      let loc =
        locationOptions &&
        locationOptions.find((opt) => opt._id === wardDetail?.location);
      console.log("loc", loc);
      setWardDetail({
        ...wardDetail,
        name:
          (wardDetail?.location ? loc?.name : "Geography") +
          " " +
          (wardDetail?.type ? wardDetail?.type : "ward type"),
      });
    }
  }, [wardDetail?.location, wardDetail?.type]);

  const submitHandler = (e) => {
    e.preventDefault();
    checkValidator();
    console.log("wardname-113", wardDetail?.name);
    console.log("wardDetail-114", wardDetail?.location);
    setIsActionCalled(true);
  };
  // formData useEffects
  useEffect(() => {
    console.log("wardDetail?.location", wardDetail?.location);
    //const loc =wardDetail?.location?JSON.parse(wardDetail?.location):null
    let formData = {
      wardId: wardDetail?.wardId,
      location: wardDetail?.location,
      name: wardDetail?.name,
      type: wardDetail?.type,
      numberOfBeds: wardDetail?.numberOfBeds,
    };
    console.log("locationId-", wardDetail?.location);
    console.log("formData-", formData);
    console.log("validation error", error);
    if (!isError() && error !== null && isActionCalled) {
      dispatch(createUpdateWard(formData)).then(({ payload }) => {
        console.log("payload-", payload);
        if (payload.success) {
          hideHandler();
        } else {
          setIsShow(true);
        }
      });
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  useEffect(() => {
    if (apiError) {
      setTimeout(() => {
        dispatch(resetPopup());
      }, 3000);
    }
  }, [apiError]);
  const hideHandler = () => {
    setIsActionCalled(false);
    resetAllValidator();
    props.onHide();
    if (selectWard === null) {
      setWardDetail({
        location: null,
        location: null,
        type: null,
        numberOfBeds: null,
      });
    } else {
      setWardDetail({
        wardId: selectWard?._id,
        location: selectWard?.locationId,
        name: selectWard?.name,
        type: selectWard?.type,
        numberOfBeds: selectWard?.numberOfBeds,
      });
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const upload = (e) => {
    console.log(e.target.files[0]);
  };

  const { onHide, ...props1 } = props;

  return (
    <>
      <Popup
        {...props1}
        onHide={hideHandler}
        size="md"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectWard ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}
        {formElements.map((element, i) => {
          return (
            (!selectWard || element.key !== "password") && (
              <Form.Group className="mb-4" controlId="formBasicEmail" key={i}>
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                {element.type === "select" ? (
                  <>
                    <Form.Select
                      disabled={selectWard ? true : false}
                      name={element.key}
                      //value={element.key=='location'? JSON.parse(wardDetail?.location) :wardDetail[element.key]}
                      value={wardDetail[element.key]}
                      onChange={(e) => {
                        console.log("selected");
                        setWardDetail({
                          ...wardDetail,
                          [element.key]: e.target.value,
                        });
                        console.log("wardDetail-225", wardDetail);
                        resetValidator(e.target.name);
                      }}
                      isInvalid={error && error[element.key]}
                    >
                      <option
                        style={{ display: "none", padding: "2px 0px" }}
                        value=""
                      >
                        Select
                      </option>
                      {element.key === "location" && locationTypes
                        ? locationTypes.map((item) => (
                            // <option value={JSON.stringify(item)}>{item.name}</option>
                            <option
                              style={{ padding: "2px 0px" }}
                              value={item._id}
                            >
                              {item.name}
                            </option>
                          ))
                        : element.key === "location" && locationOptions
                        ? locationOptions.map((item) => (
                            // <option value={JSON.stringify(item)}>{item.name}</option>
                            <option
                              style={{ padding: "2px 0px" }}
                              value={item._id}
                            >
                              {item.name}
                            </option>
                          ))
                        : element.key === "type" && wardTypes
                        ? wardTypes.map((item) => (
                            <option style={{ padding: "2px 0px" }} value={item}>
                              {item}
                            </option>
                          ))
                        : element.options.map((item) => (
                            <option style={{ padding: "2px 0px" }} value={item}>
                              {" "}
                              {item}{" "}
                            </option>
                          ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                  </>
                ) : (
                  <>
                    <Form.Control
                      disabled={element.key === "name"}
                      type={element.type}
                      name={element.key}
                      placeholder={element.placeHolder}
                      value={wardDetail && wardDetail[element.key]}
                      maxlength={element.key === "numberOfBeds" ? 3 : 50}
                      onChange={async (e) => {
                        let value = e.target.value;

                        // If field is 'numberOfBeds', validate the value
                        if (element.key === "numberOfBeds") {
                          value = value.replace(/\D/g, ""); // Remove non-numeric characters
                          if (value !== "" && Number(value) > 500) {
                            value = 500;
                          }
                        }
                        setWardDetail({
                          ...wardDetail,
                          [element.key]: value,
                        });
                        resetValidator(e.target.name);

                        console.log("wardDetail-254", wardDetail);
                      }}
                      isInvalid={error && error[element.key]}
                    />

                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                  </>
                )}
              
              </Form.Group>
            )
          );
        })}
          <Alert variant="warning" style={{fontSize:'14px'}}>Note: -Number of Beds can not be greater than 500</Alert>
        {isActionCalled && (
          <ApiResponsePopup
            {...{
              hideHandlerRes,
              isRecordUpdated: isShow,
              title: "Manage Ward",
              successMsg: successMessage,
              errorRes: apiError?.message,
            }}
          />
        )}
      </Popup>
    </>
  );
};

export default ManageWard;
